import { useState } from 'react';
import { NavLink } from 'react-router-dom';

import companyLogo from '../assets/images/logo.png';
import productLogo from "../assets/images/logo-audpro.png"

const NavbarSearch = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const getNavLinkClass = ({ isActive }) => {
    return `hover:text-gray-900 text-gray-700 text-sm ${isActive ? 'text-orange-600 text-bold' : ''}`;
  };

  return (
    <div className='bg-white shadow-sm border-b border-gray-200'>
      <nav className='relative container mx-auto p-6'>
        <div className='flex items-center justify-between'>
          {/* <div className='pt-2'>
            <img src={companyLogo} alt='' className='w-20' />
          </div> */}
          <div class="flex items-center justify-between">
            <div class="flex gap-3">
              <div>
                <img src={productLogo} alt='' className='w-8' />
              </div>
              <div>
                <h1 class="text-xl font-bold">AuditPro</h1>
                <p class="text-sm text-gray-500">Painel de Classificação Tributária</p>
              </div>
            </div>
          </div>
          <div className='hidden space-x-6 md:flex'>
            <NavLink
              to='/'
              className={getNavLinkClass}
            >
              Home
            </NavLink>
            <NavLink
              to='/classificacao-tributaria'
              className={getNavLinkClass}
            >
              Classificação Tributária
            </NavLink>
            <NavLink
              to='/credito-presumido'
              className={getNavLinkClass}
            >
              Crédito presumido
            </NavLink>
          </div>
          <button
            className={
              toggleMenu
                ? 'open block hamburger md:hidden focus:outline-none'
                : 'block hamburger md:hidden focus:outline-none'
            }
            onClick={() => setToggleMenu(!toggleMenu)}
          >
            <span className='hamburger-top'></span>
            <span className='hamburger-middle'></span>
            <span className='hamburger-bottom'></span>
          </button>
          <div>
            <div className='pt-2'>
              <img src={companyLogo} alt='' className='w-20' />
            </div>
          </div>
        </div>
        <div className='md:hidden'>
          <div
            className={
              toggleMenu
                ? 'absolute flex flex-col items-center self-end py-8 mt-10 space-y-6 font-bold bg-white sm:w-auto sm:self-center left-6 right-6 drop-shadow-md'
                : 'absolute flex-col items-center hidden self-end py-8 mt-10 space-y-6 font-bold bg-white sm:w-auto sm:self-center left-6 right-6 drop-shadow-md'
            }
          >
            {/* 3. Faça o mesmo para os links móveis (corrigi os links que estavam '/') */}
            <NavLink to='/beneficios' className={getNavLinkClass}>
              Benefícios
            </NavLink>
            <NavLink to='/como-funciona' className={getNavLinkClass}>
              Como funciona?
            </NavLink>
            <NavLink to='/faq' className={getNavLinkClass}>
              Perguntas frequentes
            </NavLink>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavbarSearch;